module.exports = __webpack_public_path__ + "img/roles.6ef6774b.svg";